export const SpecificationDataService = Symbol.for('SpecificationDataService');

export type DataWithLastModified<T> = {
    lastModified: number;
    data: T;
};

export type FigureData = {
    id: string;
    order: number;
    url: string;
    s3Key: string;
    title: string;
    scale: number | undefined;
    rotation: number;
    x: number;
    y: number;
    isAbstract?: boolean;
    annotations: {
        id: string;
        termId: string;
        type: string;
        attrs: Record<string, unknown>;
    }[];
    annotationImageBase64?: string;
};

export type TermData = {
    id: string;
    text: string;
};

/**
 * 数据服务，用于从外部获取数据并更新到领域模型中
 */
export interface SpecificationDataService {
    fetchFigures(): Promise<DataWithLastModified<FigureData[]>>;
    fetchTerms(): Promise<DataWithLastModified<TermData[]>>;
}
